module.exports = __webpack_public_path__ + "static/media/valencia-6.d79c0303.jpg";